import Http from '../../common/services/Http';
import { Paged } from '../common/types/Page';
import { IdentificationTagsSearchCriteria } from './models/IdentificationTagsSearchCriteria';
import { IdentificationTagsDto } from './models/IdentificationTagsDto';
import { SelectValueLabel } from 'common/types/SelectValueLabel';
import { CheckAvailabilityDto } from 'api/common/models/CheckAvailabilityDto';

class IdentificationTagsService {

    public getList(criteria: IdentificationTagsSearchCriteria) {
        return Http.get<Paged<IdentificationTagsDto>>('identificationtags', criteria);
                                                       
    }

    public catalog(criteria?: IdentificationTagsSearchCriteria) {
        return Http.get<SelectValueLabel[]>('identificationtags/catalog', criteria);
    }

    public getById(id: string) {
        return Http.get<IdentificationTagsDto>('identificationtags/' + id);
    }

    public create(model: IdentificationTagsDto) {
        return Http.post<string>('identificationtags', model);
    }

    public update(model: IdentificationTagsDto) {
        return Http.put('identificationtags', model);
    }

    public remove(model: IdentificationTagsDto) {
        return Http.put('identificationtags/deactivate', model);
    }

    public checkAvailability(data: CheckAvailabilityDto) {
        return Http.get<boolean>('users/check-availability', data);
    }
}

export default new IdentificationTagsService();